function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgApplicationOutline = function SvgApplicationOutline(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "pending for approval",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vgkyrukm4a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2446",
    style: {
      fill: "none"
    },
    d: "M0 0h13.714v18H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2338",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4435"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4434",
    style: {
      clipPath: "url(#vgkyrukm4a)"
    },
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 980",
    d: "M9.1 0a4.457 4.457 0 0 1 .4.313q1.987 1.978 3.968 3.961a.777.777 0 0 1 .248.591q-.008 5.755 0 11.512a1.574 1.574 0 0 1-1.336 1.6 1.527 1.527 0 0 1-.28.023H1.619A1.57 1.57 0 0 1 0 16.38V1.634A1.57 1.57 0 0 1 1.273.03.4.4 0 0 0 1.336 0zm-.662 1.054h-6.75a.556.556 0 0 0-.634.635v14.623a.556.556 0 0 0 .636.634h10.334a.557.557 0 0 0 .633-.638V5.273c-.888 0-1.749.005-2.61 0a1.866 1.866 0 0 1-.55-.088 1.555 1.555 0 0 1-1.058-1.471v-2.66m1.057.781c0 .645-.012 1.275.005 1.9a.515.515 0 0 0 .552.479h1.738a.5.5 0 0 0 .077-.013L9.495 1.835",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 981",
    d: "M6.858 8.507H3.749a.529.529 0 1 1-.005-1.053h6.217a.529.529 0 1 1 .006 1.053H6.858",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 982",
    d: "M6.836 10.617H3.692a.525.525 0 0 1-.151-1.029.668.668 0 0 1 .19-.022h6.252a.528.528 0 1 1 0 1.053H6.839",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 983",
    d: "M6.835 12.726H3.691a.525.525 0 0 1-.15-1.03.676.676 0 0 1 .19-.021h6.252a.528.528 0 1 1 0 1.053H6.839",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 984",
    d: "M5.818 13.782h2.037a.529.529 0 1 1 0 1.053H3.747a.529.529 0 1 1 0-1.053h2.071",
    style: {
      fill: "#1a1818"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApplicationOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/application_outline.7ce35ddf.svg";
export { ForwardRef as ReactComponent };